import { useOkapiKy } from "@folio/stripes/core";
import { fetchLibraryById } from "../api/libraryService";
import { useDetailEntity } from "./useDetailEntity";
export var useLibraryActions = function () {
    var kyInstance = useOkapiKy();
    var _a = useDetailEntity("library-detail", function (id) {
        return fetchLibraryById(kyInstance, id);
    }), selectedItem = _a.selectedItem, handleRowClick = _a.handleRowClick, handleCloseDetail = _a.handleCloseDetail;
    return {
        selectedLibrary: selectedItem,
        handleRowClick: function (library) { return handleRowClick(library.id); },
        handleCloseDetail: handleCloseDetail,
    };
};
